import { Component, inject, Input, OnDestroy } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslationService } from '../common';
import { LANGUAGES } from '../common/service/translation-service.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-language-select',
  imports: [MatSelectModule, MatFormFieldModule, TranslateModule, ReactiveFormsModule],
  templateUrl: './language-select.component.html',
  styleUrl: './language-select.component.scss',
})
export class LanguageSelectComponent implements OnDestroy {
  @Input() appearance: 'fill' | 'outline' = 'outline';
  readonly translate = inject(TranslationService);
  readonly options = LANGUAGES;
  readonly control = new FormBuilder().nonNullable.control(this.translate.language);
  readonly subscription = this.control.valueChanges.subscribe((language) => (this.translate.language = language));

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
